import React from 'react';

export default function FwPriceIcon({ color = 'currentColor', fontSize = '16px' }) {
  return (
    <>
      <i className='far fa-clone' style={{ color, fontSize: fontSize }}></i>
    </>
  );
}